import { defineStore } from 'pinia'
import InternalUsersService from '@/api/InternalUsersService'

export const useInternalUsersStore = defineStore('internalUsers', {
    state: () => ({
        internalUsersTableRefreshKey: 0,
        loading: false,
        loadingUserRoles: false,
        togglingUserRoles: false,
        sending: false,
        resending: false,
        deleting: false,
    }),

    getters: {},

    actions: {
        notification(severity, detail) {
            const summary = severity === 'error' ? 'Error' : 'Success'
            this.toast.add({
                severity,
                summary,
                detail,
                life: this.getToastDuration(detail, severity),
            })
        },

        async getUserRoles(id) {
            this.loadingUserRoles = true
            try {
                const { data } = await InternalUsersService.getUserRoles(id)
                return data
            } catch (error) {
                console.error(
                    `Error loading internal user roles id=${id} (stores/internalUsers/getUserRoles):`,
                    error
                )
                this.notification('error', '§ui_message.load_failed')
            } finally {
                this.loadingUserRoles = false
            }
        },

        async sendInternalInvite(data) {
            this.sending = true
            try {
                await InternalUsersService.sendInternalInvite(data)
                this.notification('success', '§ui_message.invite_sent')
            } catch (error) {
                console.error(`Error sending internal invite (stores/internalUsers/sendInternalInvite):`, error)
                this.notification('error', '§ui_message.invite_failed')
            } finally {
                this.sending = false
            }
        },

        async resendInternalInvite(id) {
            this.resending = true
            try {
                await InternalUsersService.resendInternalInvite(id)
                this.notification('success', '§ui_message.resend_successful')
                this.internalUsersTableRefreshKey += 1
            } catch (error) {
                console.error(`Error resending internal invite id=${id} (stores/internalUsers/resendInternalInvite):`, error)
                this.notification('error', '§ui_message.resend_failed')
            } finally {
                this.resending = false
            }
        },

        async deleteInternalInvite({ id }) {
            this.deleting = true
            try {
                await InternalUsersService.deleteInternalInvite(id)
                this.notification('success', '§ui_message.delete_successful')
                this.internalUsersTableRefreshKey += 1
            } catch (error) {
                console.error(`Error deleting internal invite id=${id} (stores/internalUsers/deleteInternalInvite):`, error)
                this.notification('error', '§ui_message.delete_failed')
            } finally {
                this.deleting = false
            }
        },

        async toggleUserRole(id, roleName) {
            this.togglingUserRoles = true
            try {
                await InternalUsersService.toggleUserRole(id, { role: roleName })
                this.notification('success', '§ui_message.toggle_successful')
            } catch (error) {
                console.error(
                    `Error toggling internal user roles id=${id} role=${roleName} (stores/internalUsers/toggleUserRole):`,
                    error
                )
                this.notification('error', '§ui_message.toggle_failed')
            } finally {
                this.togglingUserRoles = false
            }
        },
    },
})